import { createFileRoute } from "@tanstack/react-router";

import { RootPending } from "@/components/RootPending";
import { SignOut } from "@/views/login/sign-out";

// Outside the guest layout: that one sends a signed-in user back to the app,
// and this route is the one a signed-in user comes to.
export const Route = createFileRoute("/sign-out")({
  pendingComponent: RootPending,
  component: SignOut,
});
